import React, { Component } from "react";
import { Col, Row, FormGroup, Label, Modal } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import moment from "moment";
import {
  addUser,
  getUsers,
  getFoodDeliveryBoyById,
  updateUser,
  removeFoodDeliveryBoy,
} from "../../Endpoint/Admin/index";
import { toast } from "react-toastify";
import { exportToExcel } from "../../utils/exportToExcel";
import { ConsolePage } from "../../components/Console/ConsoleLayout";
import {
  C, Panel, Table, Btn, SearchPill, Avatar, MeterList, PanelLink, IconBtn, Pager,
} from "../../components/Console/ConsoleUI";
import { canWrite, hasModuleAccess } from "../../services/PermissionService";

/**
 * Guest directory — screen E2 of the console redesign.
 *
 * The handoff draws a wide roster beside a narrow rail of summaries. The roster
 * is the same /admin/getUsers list this screen always showed; the rail is
 * derived from that one payload rather than fetched, so nothing on the page can
 * disagree with anything else on it.
 *
 * Columns the handoff draws but the API does not carry — last stay, stays,
 * lifetime spend, loyalty tier — are not faked here. Guest records hold no
 * stay history and no points balance (loyalty lives in its own module), so the
 * roster shows what a guest record actually contains and the rail links to the
 * loyalty screens for the rest.
 *
 * Re-skin only: every request, every piece of state and every handler below is
 * the one the previous MDBDataTable screen used.
 */

const fullName = (u) => `${u.firstName || ""} ${u.lastName || ""}`.trim();

class User extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      // Server-side paging. This endpoint used to return every verified
      // customer - 2,565 on the live data - and the page drew all of them.
      page: 1,
      limit: 25,
      pagination: null,
      isLoaded: false,
      updatemodal: false,
      modal: false,
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      country: "",
      postalCode: "",
      dBoyId: "",
      success: {},
      // View-only filter. It never changes what is fetched.
      search: "",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggle = this.toggle.bind(this);
    this.updatetoggle = this.updatetoggle.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleExport = this.handleExport.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal,
      firstName: "",
      lastName: "",
      email: "",
      mobile: "",
      country: "",
      postalCode: "",
      dBoyId: "",
    });
  }

  updatetoggle() {
    this.setState({
      updatemodal: !this.state.updatemodal,
    });
  }

  handleCloseModal() {
    this.setState({
      updatemodal: false,
      modal: false,
    });
  }

  handleChange = (e) => {
    this.setState(
      {
        [e.target.id]: e.target.value,
      },
      () => {}
    );
  };

  handleSubmit(e) {
    e.preventDefault();
    const userObject = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      email: this.state.email,
      mobile: this.state.mobile,
      country: this.state.country,
      postalCode: this.state.postalCode,
      dBoyId: this.state.dBoyId,
    };
    if (this.state.dBoyId == "" || this.state.dBoyId == null) {
      addUser(userObject)
        .then((response) => {
          if (response.status !== 200) {
            toast.error(response.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: response.status === 200,
                message: "success",
                firstName: "",
                lastName: "",
                email: "",
                mobile: "",
                country: "",
                postalCode: "",
                dBoyId: "",
              },
            });
            this.getALlluser();
            this.handleCloseModal();
            toast.success(response.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    } else {
      updateUser(userObject)
        .then((updateResults) => {
          if (updateResults.status !== 200) {
            toast.error(updateResults.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            this.setState({
              handleResponse: {
                isSuccess: updateResults.status === 200,
                message: "success",

                dBoyId: "",
              },
            });
            this.getALlluser();

            this.handleCloseModal();
            toast.success(updateResults.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }
        })
        .catch((error) => {
          toast.error("error");
        });
    }
  }

  getALlluser(page = this.state.page, limit = this.state.limit, search = this.state.search) {
    getUsers(page, limit, search).then((result) => {
      this.setState({
        isLoaded: true,
        items: (result && result.data) || [],
        pagination: (result && result.pagination) || null,
        page,
        limit,
      });
    });
  }

  // Searching now asks the SERVER, so a guest on page 40 is findable. Debounced
  // so typing does not fire a request per keystroke.
  onSearch = (value) => {
    this.setState({ search: value });
    clearTimeout(this._searchTimer);
    this._searchTimer = setTimeout(() => {
      this.setState({ isLoaded: false }, () => this.getALlluser(1, this.state.limit, value));
    }, 350);
  };

  componentWillUnmount() {
    clearTimeout(this._searchTimer);
  }

  goToPage = (page) => {
    this.setState({ isLoaded: false }, () => this.getALlluser(page, this.state.limit));
  };

  changeLimit = (limit) => {
    this.setState({ isLoaded: false }, () => this.getALlluser(1, limit));
  };

  removeDeliveryBoy(id) {
    removeFoodDeliveryBoy(id)
      .then((results) => {
        toast.success(results.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        this.getALlluser();
      })
      .catch((error) => {
        toast.error("error");
      });
  }

  componentDidMount() {
    this.getALlluser();
  }

  editDeliveryBoy(id) {
    getFoodDeliveryBoyById(id)
      .then((results) => {
        this.setState({
          dBoyId: results.data._id,
          firstName: results.data.firstName,
          lastName: results.data.lastName,
          email: results.data.email,
          mobile: results.data.mobile,
          country: results.data.country,
          postalCode: results.data.postalCode,
        });
      })
      .catch((error) => {
        toast.error("error");
      });
    this.toggle();
  }

  // --- presentation ---------------------------------------------------------

  /** Client-side filter over the loaded roster. No request is made. */
  // The server does the searching now, so this just returns what it sent.
  visibleGuests() {
    return this.state.items || [];
  }

  /**
   * Export writes out the rows already on screen - now one page of them, since
   * the list is paginated. No new request, and nothing in the file that is not
   * in the table.
   */
  handleExport() {
    const rows = this.visibleGuests().map((u) => ({
      "First name": u.firstName || "",
      "Last name": u.lastName || "",
      Email: u.email || "",
      Mobile: u.mobile || "",
      Country: u.country || "",
      "Postal code": u.postalCode || "",
      Joined: u.createdAt ? moment(u.createdAt).format("YYYY-MM-DD") : "",
    }));
    if (rows.length === 0) {
      toast.error("Nothing to export");
      return;
    }
    exportToExcel(
      [{ name: "Guests", data: rows }],
      `Guests_${moment().format("YYYY-MM-DD")}`
    );
  }

  /** Countries present in the roster, biggest first — the rail's mix bars. */
  countryMix() {
    const items = this.state.items || [];
    if (items.length === 0) return [];
    const counts = {};
    items.forEach((u) => {
      const k = (u.country || "").trim() || "Not given";
      counts[k] = (counts[k] || 0) + 1;
    });
    const sorted = Object.keys(counts)
      .map((k) => ({ key: k, n: counts[k] }))
      .sort((a, b) => b.n - a.n);
    const top = sorted.slice(0, 4);
    const rest = sorted.slice(4).reduce((s, r) => s + r.n, 0);
    if (rest > 0) top.push({ key: "Other", n: rest });
    return top.map((r) => ({
      label: `${r.key} · ${r.n}`,
      value: `${Math.round((r.n / items.length) * 100)}%`,
      pct: (r.n / items.length) * 100,
    }));
  }

  /** Most recent sign-ups. Stands in for the handoff's points feed. */
  recentGuests() {
    return (this.state.items || [])
      .filter((u) => u.createdAt)
      .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
      .slice(0, 5);
  }

  renderModal() {
    const { dBoyId } = this.state;
    const editing = !!dBoyId;

    return (
      <Modal isOpen={this.state.modal} toggle={this.toggle} className="con-modal">
        <div style={{ padding: 30 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <span
              className="ms"
              style={{
                fontSize: 26, color: C.brown, background: C.iconTint,
                padding: 13, borderRadius: 16,
              }}
            >
              person
            </span>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: 22, fontWeight: 500, color: C.ink }}>
                {editing ? "Edit guest" : "Add guest"}
              </div>
              <div style={{ marginTop: 4, fontSize: 14, color: C.taupe }}>
                {editing
                  ? "Contact details used across bookings and orders"
                  : "Creates a guest record they can sign in against"}
              </div>
            </div>
            <button
              type="button"
              onClick={this.toggle}
              aria-label="Close"
              style={{
                border: 0, background: "transparent", color: C.taupeLight,
                cursor: "pointer", padding: 4, lineHeight: 1,
              }}
            >
              <span className="ms" style={{ fontSize: 22 }}>close</span>
            </button>
          </div>

          <AvForm onValidSubmit={this.handleSubmit}>
            <div style={{ marginTop: 24 }}>
              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="firstName">First name</Label>
                    <AvField
                      type="text"
                      value={this.state.firstName}
                      onChange={this.handleChange}
                      id="firstName"
                      name="firstName"
                      required
                                  errorMessage="First name is required"
                                />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="lastName">Last name</Label>
                    <AvField
                      type="text"
                      value={this.state.lastName}
                      onChange={this.handleChange}
                      id="lastName"
                      name="lastName"
                      required
                                  errorMessage="Last name is required"
                                />
                  </FormGroup>
                </Col>
              </Row>

              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="email">Email</Label>
                    <AvField
                      type="text"
                      value={this.state.email}
                      onChange={this.handleChange}
                      id="email"
                      name="email"
                      required
                                  errorMessage="Email is required"
                                />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="mobile">Mobile</Label>
                    <AvField
                      type="number"
                      min={0}
                      value={this.state.mobile}
                      onChange={this.handleChange}
                      id="mobile"
                      name="mobile"
                      required
                                  errorMessage="Mobile is required"
                                />
                  </FormGroup>
                </Col>
              </Row>

              <Row form>
                <Col md={6}>
                  <FormGroup>
                    <Label for="country">Country</Label>
                    <AvField
                      type="text"
                      value={this.state.country}
                      onChange={this.handleChange}
                      id="country"
                      name="country"
                      required
                                  errorMessage="Country is required"
                                />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <FormGroup>
                    <Label for="postalCode">Postal code</Label>
                    <AvField
                      type="text"
                      value={this.state.postalCode}
                      onChange={this.handleChange}
                      id="postalCode"
                      name="postalCode"
                      required
                                  errorMessage="Postal code is required"
                                />
                  </FormGroup>
                </Col>
              </Row>
            </div>

            <div style={{ marginTop: 8, display: "flex", gap: 12 }}>
              <button
                type="button"
                onClick={this.toggle}
                style={{
                  flex: 1, height: 52, border: "1px solid #e6d8c4", borderRadius: 26,
                  background: "#fff", color: C.slate, fontFamily: "inherit",
                  fontSize: 15, cursor: "pointer",
                }}
              >
                Cancel
              </button>
              <button
                style={{
                  flex: 1, height: 52, border: 0, borderRadius: 26,
                  background: C.brown, color: "#fff", fontFamily: "inherit",
                  fontSize: 15, cursor: "pointer",
                }}
              >
                {editing ? "Save changes" : "Add guest"}
              </button>
            </div>
          </AvForm>
        </div>
      </Modal>
    );
  }

  render() {
    const { items, isLoaded, search, pagination, limit } = this.state;
    const write = canWrite();
    const visible = this.visibleGuests();
    const mix = this.countryMix();
    const recent = this.recentGuests();

    const columns = [
      {
        key: "guest",
        label: "Guest",
        render: (u) => (
          <div style={{ display: "flex", alignItems: "center", gap: 11 }}>
            <Avatar name={fullName(u)} />
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 15, color: C.ink }}>{fullName(u) || "Unnamed guest"}</div>
              <div style={{ fontSize: 12, color: C.taupeLight }}>{u.mobile || "No phone"}</div>
            </div>
          </div>
        ),
      },
      {
        key: "email",
        label: "Email",
        render: (u) => (
          <span style={{ color: u.email ? C.brownDeep : C.taupeLight }}>{u.email || "—"}</span>
        ),
      },
      {
        key: "country",
        label: "Country",
        render: (u) => (
          <span style={{ color: u.country ? C.brownDeep : C.taupeLight }}>{u.country || "—"}</span>
        ),
      },
      {
        key: "createdAt",
        label: "Joined",
        render: (u) =>
          u.createdAt ? (
            moment(u.createdAt).format("D MMM YYYY")
          ) : (
            <span style={{ color: C.taupeLight }}>—</span>
          ),
      },
      ...(write
        ? [
            {
              key: "actions",
              label: "",
              width: 96,
              align: "right",
              render: (u) => (
                <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                  <IconBtn
                    icon="edit"
                    title={`Edit ${fullName(u) || "guest"}`}
                    onClick={() => this.editDeliveryBoy(u._id.toString(), u)}
                  />
                  <IconBtn
                    icon="delete"
                    tone="bad"
                    title={`Remove ${fullName(u) || "guest"}`}
                    onClick={() => {
                      if (
                        window.confirm(
                          `Remove ${fullName(u) || "this guest"} from the directory?`
                        )
                      ) {
                        this.removeDeliveryBoy(u._id.toString());
                      }
                    }}
                  />
                </div>
              ),
            },
          ]
        : []),
    ];

    return (
      <ConsolePage
        title="Guest directory"
        subtitle={
          isLoaded
            ? (() => {
                // items is ONE PAGE of guests. Reporting its length as the
                // total read as "25 guests" when there are 2,565.
                const total = (pagination && pagination.totalCount) || (items || []).length;
                const shown = (items || []).length;
                if (search.trim()) {
                  return `${total} matching "${search.trim()}"${total > shown ? ` · showing ${shown}` : ""}`;
                }
                return total > shown
                  ? `${total} guests · showing ${shown}`
                  : `${total} guest${total === 1 ? "" : "s"}`;
              })()
            : "Loading the directory…"
        }
        actions={
          <React.Fragment>
            <SearchPill
              value={search}
              onChange={this.onSearch}
              placeholder="Name, phone or email"
              width={260}
            />
            <Btn kind="quiet" icon="download" onClick={this.handleExport}>
              Export
            </Btn>
            {write && (
              <Btn icon="person_add" onClick={this.toggle}>
                Add guest
              </Btn>
            )}
          </React.Fragment>
        }
      >

        <div style={{ display: "grid", gridTemplateColumns: "1.5fr 1fr", gap: 20, alignItems: "start" }}>
          <Panel style={{ padding: 0 }}>
            <div style={{ padding: "6px 8px" }}>
              <Table
                columns={columns}
                rows={visible}
                empty={
                  !isLoaded
                    ? "Loading guests…"
                    : search.trim()
                    ? "No guest matches that search."
                    : "No guests have signed up yet."
                }
              />
            </div>
            {isLoaded && (
              <div style={{ padding: "6px 22px 16px", borderTop: `1px solid ${C.tint}` }}>
                <Pager
                  page={(pagination && pagination.currentPage) || 1}
                  totalPages={(pagination && pagination.totalPages) || 1}
                  total={pagination && pagination.totalCount}
                  limit={(pagination && pagination.limit) || limit}
                  onPage={this.goToPage}
                  onLimit={this.changeLimit}
                  noun="guests"
                />
              </div>
            )}
          </Panel>

          <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
            <Panel title="Where guests are from">
              <MeterList items={mix} empty="No guests to summarise yet" />
            </Panel>

            <Panel
              title="Newest guests"
              style={{ display: "flex", flexDirection: "column", minHeight: 240 }}
            >
              <div style={{ marginTop: 14, display: "flex", flexDirection: "column", gap: 13 }}>
                {recent.length === 0 && (
                  <div style={{ fontSize: 14, color: C.taupeLight }}>
                    No sign-up dates on these records.
                  </div>
                )}
                {recent.map((u) => (
                  <div
                    key={u._id}
                    style={{
                      display: "flex", alignItems: "center",
                      justifyContent: "space-between", gap: 12, fontSize: 14,
                    }}
                  >
                    <span style={{ color: "#3a3a3a", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                      {fullName(u) || u.email || "Unnamed guest"}
                    </span>
                    <span style={{ color: C.taupe, flex: "0 0 auto" }}>
                      {moment(u.createdAt).fromNow()}
                    </span>
                  </div>
                ))}
              </div>
              {/* Points and tiers live in the loyalty module, behind its own
                  gate — only linked for accounts that can open it. */}
              {hasModuleAccess("LOYALTY") && (
                <PanelLink onClick={() => this.props.history.push("/loyalty/accounts")}>
                  Loyalty accounts
                </PanelLink>
              )}
            </Panel>
          </div>
        </div>

        {this.renderModal()}
      </ConsolePage>
    );
  }
}

export default User;
